import styled from "styled-components";
import {JackpotToastSuggestedGamesTitleDefaultBox} from "./jackpot-toast-suggested-games-title.default.box";

export const JackpotToastSuggestedGamesTitleCasino777Box = styled(JackpotToastSuggestedGamesTitleDefaultBox)`
    ${props => props.theme.font.presets.body};
    font-size: 1.8rem;
`;